import { type Locale } from '@mfw/translations';

import type {
  UiCreateSchedule,
  UiCreateScheduleWorkoutBatch,
  UiEditSchedule,
  ApiSchedule,
  UiSchedule,
} from '../../schemas/schedule.schema';

import { createWorkoutApiArgs, mapWorkoutFromApi } from './workouts.mappers';
import { createProgramApiArgs, mapProgramFromApi } from './programs.mappers';

export const createScheduleArgs = (
  args: (UiCreateSchedule | UiEditSchedule) & { organizationId?: string },
) => {
  return {
    ...args,
    ...(args.organizationId
      ? { organizationId: args.organizationId }
      : { organizationId: null }),
    ...(args.program ? { program: createProgramApiArgs(args.program) } : {}),
    ...(args.workout ? { workout: createWorkoutApiArgs(args.workout) } : {}),
  };
};

export const createScheduleWorkoutBatchArgs = (
  args: UiCreateScheduleWorkoutBatch & { organizationId?: string },
) => {
  return {
    ...args,
    ...(args.organizationId
      ? { organizationId: args.organizationId }
      : { organizationId: null }),
    workouts: args.workouts.map((entry) => ({
      ...entry,
      workout: createWorkoutApiArgs(entry.workout),
    })),
  };
};

export const mapScheduleFromApi = (
  schedule: ApiSchedule,
  locale: Locale,
): UiSchedule => {
  return {
    ...schedule,
    id: schedule.id,
    clientName: schedule.client?.name ?? '',
    contentLocked: schedule.contentLocked ?? false,
    organizationId: schedule.organizationId,
    program: mapProgramFromApi({ ...schedule.program, categories: [] }, locale),
    trainerName: schedule.trainer?.name ?? '',
    // Spread guards against `schedule.workout` being undefined (non-workout
    // events) the same way the old `categories: []` override used to —
    // `mapWorkoutFromApi` reads straight off `.id` with no optional chaining.
    workout: mapWorkoutFromApi({ ...schedule.workout }, locale),
  };
};
